import {useFormik} from 'formik';
import {useSchemes} from '../../../shared';
import {FundRepresentativeModel, useFundRepresentativeById} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseEditFundRepresentativeFormProps = {
  setOpen: (open: boolean) => void;
  representativeId: string;
  representative?: FundRepresentativeModel;
};

export const useEditFundRepresentativeForm = ({setOpen, representativeId, representative}: UseEditFundRepresentativeFormProps) => {
  const {displayNameSchema} = useSchemes();
  const {updateMutation} = useFundRepresentativeById(representativeId);

  const onSubmit = async (values: {displayName: string}) => {
    try {
      await updateMutation.mutateAsync({representativeId, displayName: values.displayName});
      setOpen(false);
    } catch {
      // Ошибка отображается через submitError (updateMutation.error)
    }
  };

  const formik = useFormik({
    initialValues: {
      displayName: representative?.displayName || '',
    },
    validationSchema: Yup.object({
      displayName: displayNameSchema,
    }),
    onSubmit,
    enableReinitialize: true,
  });

  return {
    ...formik,
    isLoading: updateMutation.isPending,
    submitError: updateMutation.error
      ? (updateMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    submitForm: () => formik.handleSubmit(),
  };
};
